export default "/_next/static/images/product--user-legacy-8f772f82adb361101e83a068fcdea54f.svg";